import { render, staticRenderFns } from "./PuntiPat.vue?vue&type=template&id=8fa69682&scoped=true&"
import script from "./PuntiPat.vue?vue&type=script&lang=js&"
export * from "./PuntiPat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa69682",
  null
  
)

export default component.exports